import React, { useEffect, useState } from 'react';
import './SelectActionWidget.scss';
import Icon, { IconType } from '../icon/Icon';
import Button, { ButtonState } from '../button/Button';

type SelectActionWidgetProps = {
  selectedSystems: any[];
  firstColDef?: string;
  onRemoveSystem: (id: number) => void;
  onClearAll: () => void;
  onCompare: () => void;
  onSaveFavorites: () => void;
};

const SelectActionWidget: React.FC<SelectActionWidgetProps> = ({
  selectedSystems,
  firstColDef,
  onRemoveSystem,
  onClearAll,
  onCompare,
  onSaveFavorites,
}) => {
  const [expanded, setExpanded] = useState(false);
  const selectedCount = selectedSystems.length;

  useEffect(() => {
    if (selectedCount === 0) {
      setExpanded(false);
    }
  }, [selectedCount]);

  if (selectedCount === 0) {
    return null;
  }

  const getTitle = (system) => {
    if (firstColDef && system[firstColDef]) {
      return system[firstColDef];
    }
    return 'Selected Items';
  };

  return selectedCount === 0 ? null : (
    <div className="select-action-widget">
      <div className="select-action-header">
        <button
          className="expand-toggle"
          onClick={() => setExpanded((prev) => !prev)}
        >
          <span className="u-text-small">Selected items ({selectedCount})</span>
          <Icon
            iconType={IconType.ArrowDown}
            className={`u-icon-small expand-icon ${expanded ? 'rotated' : ''}`}
          />
        </button>

        <div className="action-buttons">
          <Button
            onClick={onSaveFavorites}
            icon={IconType.Favorites}
            isSmall
            extraClasses="custom-button"
          />
          <Button
            onClick={onCompare}
            isSmall
            label="Compare"
            extraClasses="custom-button"
            state={
              selectedCount > 1 ? ButtonState.DEFAULT : ButtonState.DISABLED
            }
          />
          <Button
            onClick={onClearAll}
            icon={IconType.Close}
            extraClasses="custom-button"
          />
        </div>
      </div>

      <div className={`expandable-wrapper ${expanded ? 'expanded' : ''}`}>
        <ul className="selected-system-list">
          {selectedSystems.map((system) => (
            <li key={system.id} className="selected-system-item">
              <div>
                <div>
                  <span className="system-name">{getTitle(system)}</span>
                </div>
                <div>
                  {system.description && (
                    <span className="system-description-name">
                      {system.description}
                    </span>
                  )}
                </div>
              </div>
              <button
                className="remove-button"
                onClick={() => onRemoveSystem(system.id)}
                aria-label={`Remove ${getTitle(system)}`}
              >
                <Icon iconType={IconType.Close} className="u-icon-small" />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SelectActionWidget;
